module.exports = __webpack_public_path__ + "img/alert-info-new.2e35cf39.svg";